export const appName = import.meta.env.VITE_APP_NAME || 'JDP Cognito Invoice';
